import { DropDownComponent } from './dropdown.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DropDownService } from './dropdown.service'
@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HttpModule],
  exports: [DropDownComponent],
  declarations: [DropDownComponent],
  providers: [DropDownService]
})
export class DropDownModule { }
